import { useAccountContext } from '~/providers/AccountProvider';

export type UseIsAutomationOwnedByViewerResult = {
  isOwnedByViewer: boolean;
};

/**
 * Automations store `createdBy` as an account id (same as canvas/skills ownership checks).
 * Session access is keyed on account id; deny when ownership cannot be established.
 */
export const useIsAutomationOwnedByViewer = (
  automationCreatedBy: string | undefined,
): UseIsAutomationOwnedByViewerResult => {
  const { data: account } = useAccountContext();

  const createdBy = automationCreatedBy?.trim();
  const viewerAccountId = account?.id;

  const isOwnedByViewer = Boolean(createdBy && viewerAccountId) && createdBy === viewerAccountId;

  return { isOwnedByViewer };
};
